import { PProgress } from 'p-progress';
import { IProgressPromise, IProgressPromiseGenerator, PromiseExecutor } from '../interface/promise';

function Promise<ValueType>(executor: PromiseExecutor<ValueType>): IProgressPromise<ValueType> {
    return new PProgress(executor);
}

const module: IProgressPromiseGenerator = {
    promise: Promise,
};

export default module;
